import { createSelector } from '@reduxjs/toolkit';
import { getCheapestPackagePriceWithAlternatives } from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { getPriceChangesArray } from './actualization';
import {
  currentPriceSelector,
  getFlightFuelCharge,
  getPackageFullPrice,
} from './order';
import { getNetPrice, getSurcharge } from './package';
import { getIsHomePath } from './router';
import { cheapestTOExtrasTotalPriceSelector } from './services';

/**
 * Этот селектор возвращает предыдущую цену, которую видел юзер - на первой
 * актуализации это цена с страницы отеля (net_price из актуализации + surcharge),
 * далее net_price + extras + fuel_charge
 */
export const oldPriceSelector = createSelector(
  [getPriceChangesArray, getNetPrice, getSurcharge, currentPriceSelector],
  (priceChangesArray, origNetPrice, surcharge, currentPrice): number => {
    const netPriceFromHotelPage =
      (priceChangesArray && priceChangesArray[0]) || origNetPrice;
    const priceFromHotelPage = Number(netPriceFromHotelPage) + surcharge;

    return currentPrice || priceFromHotelPage;
  },
);

/**
 * Этот селектор возвращает новую цену после актуализации
 * (или после актуализации альтернативных пакетов, если они включены),
 * вычисляется по формуле net_price + extras + fuel_charge для:
 *  1) самого дешевого перелета, если это первый шаг чекаута
 *  2) выбранного перелета, если второй или третий шаг
 */
export const newPriceSelector = createSelector(
  [
    getIsHomePath,
    getFlightFuelCharge,
    getCheapestPackagePriceWithAlternatives,
    cheapestTOExtrasTotalPriceSelector,
    getPackageFullPrice,
  ],
  (
    isFirstPage,
    fuelCharge,
    cheapestNetPrice,
    cheapestMandatoryExtrasPrice,
    fullPrice,
  ): number => {
    const newPrice = isFirstPage
      ? cheapestNetPrice + cheapestMandatoryExtrasPrice + fuelCharge
      : fullPrice;

    return newPrice;
  },
);
